import { CoreModel } from '../core/core.model';
export class TabsCardModel extends CoreModel {
/**
 * Card label
 */
label?: string;
/**
 * @hidden 
 * It is the constructor for the TabsCardModel component. It takes the values to create the TabsCardModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function TabsCardModel_tsickle_Closure_declarations() {
/**
 * Card label
 * @type {?}
 */
TabsCardModel.prototype.label;
}

